import React, { useState } from 'react'
import { useContext } from 'react'
import { CandidatesContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCandidateAddresses, saveCandidateAddresses } from '../../../actions/candidates'
import { getSubjects } from '../../../actions/common'
import styles from './styles.module.scss'
import Button from '../../../components/Button'
import { Checkbox, Input, Select } from '../../../components/ModalInputs'
import { useFormik } from 'formik'


const ADDRESS_FIELDS = ['index', 'subject', 'district', 'city', 'street', 'home', 'liter', 'flat']

export default function Adresses() {

  const { candidateId, closeModal } = useContext(CandidatesContext)
  const dispatch = useDispatch()
  const { address: data } = useSelector(state => state.candidates.data)
  const { subjects } = useSelector(state => state.common)

  const [sameAsRegistration, setSameAsRegistration] = useState(false)
  const [sameAsActual, setSameAsActual] = useState(false)

  useEffect(() => {
    candidateId !== 'add' && dispatch(getCandidateAddresses(candidateId))
    !subjects && dispatch(getSubjects())
  }, [])

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (formData) => {
      dispatch(saveCandidateAddresses(candidateId, formData))
    }
  })

  const handleSameAsRegistration = (checked) => {
    setSameAsRegistration(checked)
    if (checked) {
      ADDRESS_FIELDS.forEach(field =>
        setFieldValue(`actual${field}`, values[`registration${field}`] ?? '')
      )
    }
  }

  const handleSameAsActual = (checked) => {
    setSameAsActual(checked)
    if (checked) {
      ADDRESS_FIELDS.forEach(field =>
        setFieldValue(`mail${field}`, values[`actual${field}`] ?? '')
      )
    }
  }

  const renderSubjects = () =>
    subjects?.map(({ idsubject, subject }) => <option key={idsubject} value={idsubject}>{subject}</option>)

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>

          <>
            <h5>Адрес регистрации</h5>
            <div className={styles.inputsRow}>
              <Input
                label='Индекс'
                name='registrationindex'
                value={values.registrationindex || ''}
                onChange={handleChange}
              />
              <Select
                style={{ width: '350px' }}
                label='Субъект РФ'
                name='registrationsubject'
                value={values.registrationsubject || ''}
                onChange={handleChange}
              >
                {renderSubjects()}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '550px' }}
                label='Район'
                name='registrationdistrict'
                value={values.registrationdistrict || ''}
                onChange={handleChange}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '350px' }}
                label='Город / Нас. пункт'
                name='registrationcity'
                value={values.registrationcity || ''}
                onChange={handleChange}
              />
              <Input
                style={{ width: '350px' }}
                label='Улица'
                name='registrationstreet'
                value={values.registrationstreet || ''}
                onChange={handleChange}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Дом'
                name='registrationhome'
                value={values.registrationhome || ''}
                onChange={handleChange}
              />
              <Input
                label='Корпус'
                name='registrationliter'
                value={values.registrationliter || ''}
                onChange={handleChange}
              />
              <Input
                label='Квартира'
                name='registrationflat'
                value={values.registrationflat || ''}
                onChange={handleChange}
              />
            </div>
          </>

          <>
            <h5>Адрес фактического проживания</h5>
            <div className={styles.inputsRow}>
              <Input
                label='Индекс'
                name='actualindex'
                value={values.actualindex || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
              <Select
                style={{ width: '350px' }}
                label='Субъект РФ'
                name='actualsubject'
                value={values.actualsubject || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              >
                {renderSubjects()}
              </Select>
              <Checkbox
                style={{ marginLeft: 'auto', alignSelf: 'center' }}
                label='Совпадает с адресом регистрации'
                checked={sameAsRegistration}
                onChange={(e) => handleSameAsRegistration(e.target.checked)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '550px' }}
                label='Район'
                name='actualdistrict'
                value={values.actualdistrict || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '350px' }}
                label='Город / Нас. пункт'
                name='actualcity'
                value={values.actualcity || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
              <Input
                style={{ width: '350px' }}
                label='Улица'
                name='actualstreet'
                value={values.actualstreet || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Дом'
                name='actualhome'
                value={values.actualhome || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
              <Input
                label='Корпус'
                name='actualliter'
                value={values.actualliter || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
              <Input
                label='Квартира'
                name='actualflat'
                value={values.actualflat || ''}
                onChange={handleChange}
                disabled={sameAsRegistration}
              />
            </div>
          </>

          <>
            <h5>Адрес для переписки</h5>
            <div className={styles.inputsRow}>
              <Input
                label='Индекс'
                name='mailindex'
                value={values.mailindex || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
              <Select
                style={{ width: '350px' }}
                label='Субъект РФ'
                name='mailsubject'
                value={values.mailsubject || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              >
                {renderSubjects()}
              </Select>
              <Checkbox
                style={{ marginLeft: 'auto', alignSelf: 'center' }}
                label='Совпадает с адресом фактического проживания'
                checked={sameAsActual}
                onChange={(e) => handleSameAsActual(e.target.checked)}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '550px' }}
                label='Район'
                name='maildistrict'
                value={values.maildistrict || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                style={{ width: '350px' }}
                label='Город / Нас. пункт'
                name='mailcity'
                value={values.mailcity || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
              <Input
                style={{ width: '350px' }}
                label='Улица'
                name='mailstreet'
                value={values.mailstreet || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Дом'
                name='mailhome'
                value={values.mailhome || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
              <Input
                label='Корпус'
                name='mailliter'
                value={values.mailliter || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
              <Input
                label='Квартира'
                name='mailflat'
                value={values.mailflat || ''}
                onChange={handleChange}
                disabled={sameAsActual}
              />
            </div>
          </>

        </div>
      </div>
      <div className={styles.modalFooter}>
        <div>
          <div>Создал: </div>
          <div>Изменил: </div>
        </div>
        <Button mode='white' onClick={handleSubmit}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </>
  )
}
